import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-247">
    <App data-id="element-248" />
  </BrowserRouter>, document.getElementById('root'));